var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center w-50%"},[_c('h1',{},[_vm._v("Your session will time out in:")]),_c('br'),_c('h2',{staticClass:"display-4"},[_vm._v(_vm._s(_vm.timer))])])}
var staticRenderFns = []

export { render, staticRenderFns }